import React from "react";
import { CheckCircle2Icon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerIncludes } from "../../data/content";
export function OfferSection() {
  return <section id="offer" className="bg-cream px-4 py-16 sm:px-5 sm:py-24" aria-labelledby="offer-title" data-id="element-239" data-mp="ajl2o9lt0gll">
      <div className="mx-auto max-w-3xl" data-id="element-240" data-mp="6i9m0tkwr5pj">
        <div className="text-center" data-id="element-241" data-mp="6jazf4pec4af">
          <p className="inline-block rounded-lg bg-alert px-3 py-1.5 text-xs sm:text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-242" data-mp="1pya0scw7tgm">
            Special launch offer
          </p>
          <h2 id="offer-title" className="mt-4 font-serif text-[32px] leading-[1.12] sm:text-5xl font-bold text-ink text-balance" data-id="element-243" data-mp="3nxy90zxuno0a">
            Here's Everything You'll Receive Today
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_-24px_rgba(11,31,63,0.45)] ring-4 ring-navy" data-id="element-244" data-mp="3ewhz0tay5nwl">
          <img src={images.mockup} alt="Complete Otoplasty Clinical Pathway System bundle" className="block w-full bg-white" loading="lazy" data-id="element-245" data-mp="1aqfsuea8o22m" />

          <div className="px-5 pb-8 sm:px-10 sm:pb-10" data-id="element-246" data-mp="10tuolv61muzu">
            <dl className="divide-y divide-ink/10 border-y border-ink/10" data-id="element-247" data-mp="10vfirjog4bx6">
              <div className="flex items-start justify-between gap-4 py-4" data-id="element-248" data-mp="15tz4biz4nlp0">
                <dt className="text-base sm:text-lg font-semibold text-ink" data-id="element-249" data-mp="1tiruszwzd1c8">
                  Otoplasty Clinical Pathway System™
                  <span className="block text-sm font-normal text-ink/60" data-id="element-250" data-mp="1yga44rewtikr">6 Premium Volumes</span>
                </dt>
                <dd className="text-base sm:text-lg font-bold text-ink/60 line-through decoration-alert decoration-2" data-id="element-251" data-mp="1khk6nao6hgvv">$97</dd>
              </div>
              <div className="flex items-start justify-between gap-4 py-4" data-id="element-252" data-mp="92wucmo132c9">
                <dt className="text-base sm:text-lg font-semibold text-ink" data-id="element-253" data-mp="9517lv7thdp7">
                  5 Professional Bonuses
                  <span className="block text-sm font-normal text-ink/60" data-id="element-254" data-mp="2fqnqjetj6s20">Reference value</span>
                </dt>
                <dd className="text-base sm:text-lg font-bold text-ink/60 line-through decoration-alert decoration-2" data-id="element-255" data-mp="2arkl3t9n2jti">$197</dd>
              </div>
              <div className="flex items-center justify-between gap-4 py-4" data-id="element-256" data-mp="25zawqho69rtc">
                <dt className="text-sm sm:text-base font-extrabold uppercase tracking-wider text-ink" data-id="element-257" data-mp="2119hy8xs4eno">Total reference value</dt>
                <dd className="text-xl sm:text-2xl font-extrabold text-alert line-through decoration-2" data-id="element-258" data-mp="1wycua3tdtscv">$294</dd>
              </div>
            </dl>

            <div className="mt-8 text-center" data-id="element-259" data-mp="1n1gklurqz06q">
              <p className="text-sm sm:text-base font-extrabold uppercase tracking-[0.18em] text-navy" data-id="element-260" data-mp="1n4chrgvrtku4">Today: just</p>
              <p className="mt-1 font-serif text-[88px] sm:text-[112px] leading-none font-extrabold text-cta" data-id="element-261" data-mp="3hgap1dais6nd">
                $27<span className="ml-2 align-top text-2xl sm:text-3xl font-sans font-bold text-ink/70" data-id="element-262" data-mp="3cgodd8acaygo">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold uppercase tracking-wider text-ink/70" data-id="element-263" data-mp="3kxf92jzm1uvl">One-time payment</p>
              <p className="mx-auto mt-4 flex max-w-md items-center justify-center gap-2 rounded-xl bg-brand-soft px-4 py-2.5 text-sm sm:text-[15px] font-semibold text-navy" data-id="element-264" data-mp="3oy8wzdd1z9oh">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-265" data-mp="2kh4fzrvidv3" />
                Automatic currency conversion — checkout shows the price in your local currency.
              </p>
            </div>

            <ul className="mx-auto mt-8 max-w-md space-y-3" data-id="element-266" data-mp="361z95yccn4ra">
              {offerIncludes.map(item => <li key={item} className="flex gap-3 text-base text-ink" data-id="element-267" data-mp="3az9aab93p4uy">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-268" data-mp="3fzdqe063jxkn" />
                  <span data-id="element-269" data-mp="qal5q0hla1ix">{item}</span>
                </li>)}
            </ul>

            <p className="mx-auto mt-6 max-w-xl text-center text-[15px] leading-relaxed text-ink/70" data-id="element-270" data-mp="v8d6zl44izzs">
              For less than the cost of many professional educational resources, you'll receive a structured otoplasty learning system
              you can revisit whenever you study the procedure.
            </p>

            <div className="mt-8" data-id="element-271" data-mp="2d7kmes6t60lf">
              <ScarcityBar data-id="element-272" data-mp="2d4expe23d0q8" />
            </div>

            <div className="mt-6" data-id="element-273" data-mp="2875cybpndd8q">
              <CtaButton label="Yes, I want Otoplasty Clinical Pathway System™" pulse data-id="element-274" data-mp="285vehlevu31k" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-ink/65" data-id="element-275" data-mp="2n3e8b26f36fv">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="2i4ta18aq6wu2" />
                Secure checkout · Instant digital access · 7-day guarantee
              </p>
            </div>

            <div className="mt-8" data-id="element-277" data-mp="2rv5pim3onztc">
              <Countdown data-id="element-278" data-mp="2rw7ezvlg4oul" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}